"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuPopper = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _DropdownPopper = require("../DropdownPopper/DropdownPopper");
/**
 * A `DropdownPopper` used specifically for `Menu` components.
 *
 * @extends DropdownPopper
 * @since 7.28.0
 */

var MenuPopper = /*#__PURE__*/(0, _styledComponents.default)(function (props) {
  return /*#__PURE__*/_react.default.createElement(_DropdownPopper.DropdownPopper, props);
}).withConfig({
  displayName: "MenuPopper",
  componentId: "c11n-8-107-0__sc-mwvf22-0"
})([""]);
exports.MenuPopper = MenuPopper;
MenuPopper.displayName = 'MenuPopper';
MenuPopper.propTypes = {
  /**
   * https://www.w3.org/TR/wai-aria-1.1/#aria-haspopup
   */
  'aria-haspopup': _propTypes.default.oneOf(['menu']),
  /**
   * The `Trigger` `generateLabelledBy` prop.
   */
  'generateLabelledBy': _propTypes.default.bool,
  /**
   * Will close the Menu when the trigger is no longer visible in the viewport.
   */
  'shouldCloseOnViewportLeave': _propTypes.default.bool
};
MenuPopper.defaultProps = {
  'aria-haspopup': 'menu',
  'generateLabelledBy': true,
  'shouldCloseOnViewportLeave': false
};

/** @component */